module.exports = __webpack_public_path__ + "static/img/logo_10.d5a7491.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/logo_10.png
// module id = UZvP
// module chunks = 1